import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null = checking, false = anon
  const [error, setError] = useState("");

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me", {
        // 401 on anon load is expected; don't pollute console
        validateStatus: (s) => s < 500,
      });
      if (data && data.id) setUser(data);
      else setUser(false);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
